import React, { useState } from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Tabs } from './ui/tabs';
import { FolderOpen, MessageCircle, ArrowLeft, Users, Phone, Database } from 'lucide-react';
import DocumentManagementContent from './DocumentManagementContent';
import LogsContent from './LogsContent';
import UserManagement from './UserManagement';
import WhatsAppManagement from './WhatsAppManagement';
import DatasetManagement from './DatasetManagement';
import { useNavigate } from 'react-router-dom';

const tabs = [
  { id: 'documents', label: 'Documents', icon: FolderOpen },
  { id: 'logs', label: 'Logs', icon: MessageCircle },
  { id: 'users', label: 'Utilisateurs', icon: Users },
  { id: 'whatsapp', label: 'WhatsApp', icon: Phone },
  { id: 'dataset', label: 'Dataset', icon: Database },
];

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('documents');

  return (
    <div style={{overflow: 'auto', height: 'auto', minHeight: '100vh'}} className="bg-gradient-to-br from-slate-50 via-blue-50 to-cyan-50">
      {/* Header */}
      <div className="bg-white/90 backdrop-blur-xl border-b border-slate-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-2 sm:gap-4 min-w-0">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate('/')}
                className="flex items-center gap-1.5 text-slate-600 hover:text-slate-800 flex-shrink-0 px-2 sm:px-3"
              >
                <ArrowLeft className="w-4 h-4" />
                <span className="hidden sm:inline">Retour au chat</span>
              </Button>
              <div className="h-6 w-px bg-slate-300 hidden sm:block flex-shrink-0" />
              <div className="flex items-center gap-2 sm:gap-3 min-w-0">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-xl flex items-center justify-center shadow-md p-1 flex-shrink-0">
                  <img
                    src="https://customer-assets.emergentagent.com/job_mono-lift/artifacts/v6skdov3_Aprolis%20picto.png"
                    alt="Aprolis Logo"
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="min-w-0">
                  <h1 className="text-base sm:text-xl font-bold text-slate-800 truncate">Administration Axia</h1>
                  <p className="text-xs text-slate-600 hidden sm:block">Gestion des documents et monitoring</p>
                </div>
              </div>
            </div>
            <Badge variant="secondary" className="bg-blue-100 text-blue-700 border-blue-200 hidden md:inline-flex flex-shrink-0">
              Dashboard Admin
            </Badge>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-4 sm:py-8" style={{overflow: 'visible'}}>
        <div className="shadow-xl border-0 bg-white/95 backdrop-blur-sm rounded-lg" style={{overflow: 'visible'}}>
          <div className="p-4 sm:p-6 pb-4 sm:pb-6">
            <h2 className="text-lg sm:text-2xl font-bold text-slate-800 mb-4 sm:mb-6">
              Tableau de bord
            </h2>
          </div>
          <div className="px-3 sm:px-6 pb-4 sm:pb-6" style={{overflow: 'visible'}}>
            <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4 sm:space-y-6">
              {/* Responsive tabs: horizontal scroll on mobile */}
              <div className="overflow-x-auto -mx-3 px-3 sm:mx-0 sm:px-0 pb-1">
                <div className="inline-flex w-full sm:w-auto bg-gray-100 p-1 rounded-lg min-w-max">
                  {tabs.map(tab => {
                    const Icon = tab.icon;
                    return (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center justify-center gap-1.5 px-3 sm:px-4 py-2 rounded-md text-xs sm:text-sm font-medium transition-colors whitespace-nowrap ${
                          activeTab === tab.id
                            ? 'bg-white text-slate-900 shadow-sm'
                            : 'text-slate-600 hover:text-slate-900'
                        }`}
                      >
                        <Icon className="w-4 h-4 flex-shrink-0" />
                        <span className="hidden xs:inline sm:inline">{tab.label}</span>
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="space-y-4 sm:space-y-6" style={{overflow: 'visible'}}>
                {activeTab === 'documents' && <DocumentManagementContent />}
                {activeTab === 'logs' && <LogsContent />}
                {activeTab === 'users' && <UserManagement />}
                {activeTab === 'whatsapp' && <WhatsAppManagement />}
                {activeTab === 'dataset' && <DatasetManagement />}
              </div>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
